<template>
    <b-form-group class="m-0" >
        <b-form-radio-group 
            id="options" 
            name="group-radios"
            v-model="valuation"
        >
            <b-form-radio class="mt-1" value="1"><h5>1 - Nada Satisfecho/a</h5></b-form-radio>
            <b-form-radio class="mt-1" value="2"><h5>2 - Poco Satisfecho/a</h5></b-form-radio>
            <b-form-radio class="mt-1" value="3"><h5>3 - Algo Satisfecho/a</h5></b-form-radio>
            <b-form-radio class="mt-1" value="4"><h5>4 - Muy Satisfecho/a</h5></b-form-radio>
            <b-form-radio class="mt-1" value="5"><h5>5 - Plenamente Satisfecho/a</h5></b-form-radio>
        </b-form-radio-group>

    </b-form-group>
</template>

<script>
    export default {
        name: "ValuationSelector",
        props: {
            value: Number
        },
        data: function (e) {
            return {
                valuation: this.value
            }
        },
        watch: {
            'valuation': function(e){
                this.$emit('input', parseInt(this.valuation));
            },
        }
    }
</script>

<style type="text/css">
    .custom-control {
        display: block !important;
    }
</style>